const ACCESS_TOKEN = 'video-transcript-access-token'
const LEGACY_SESSION_ROLE = 'video-transcript-session-role'

export const tokenStorage = {
  getAccess: () => sessionStorage.getItem(ACCESS_TOKEN),
  set: (access: string) => {
    sessionStorage.setItem(ACCESS_TOKEN, access)
    sessionStorage.removeItem(LEGACY_SESSION_ROLE)
  },
  clear: () => {
    sessionStorage.removeItem(ACCESS_TOKEN)
    sessionStorage.removeItem(LEGACY_SESSION_ROLE)
  },
}
